import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Button from "components/Button";
import CorneredCard from "components/CorneredCard";
import AnimatedArrow from "components/AnimatedArrow";
import { ICultivationAdvice, IAccountMessage, IMeta } from "models/.";
import { markAsRead } from "../app/actions";
import getVar, { CUSTOM_SETTINGS } from "constants/.";
import { URLS } from "constants/urlConstants";
import CultivationAdviceActions from "../myCultivationAdvice/actions";
import Pagination from "components/Table/partials/Pagination";

import "./style.scss";

interface IProps {
  local: string;
  getCultivationAdvices: (meta?: IMeta, onlyPublished?: boolean) => void;
  cultivationAdvices: ICultivationAdvice[];
  accountMessages: IAccountMessage[];
  count: number;
}

interface IState {
  currentPage: number;
  pageSize: number;
}

class CultivationAdvices extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      pageSize: 10,
    };
  }

  public componentDidMount() {
    const savedSettings = JSON.parse(
      localStorage.getItem("customSettings") || "{}"
    );
    const pageSize = _.get(
      savedSettings,
      `${CUSTOM_SETTINGS.cultivationAdvice}.pageSize`,
      10
    );

    this.setState({ pageSize });
    this.props.getCultivationAdvices({ pageSize }, true);
  }

  private onClickHandle = async (item, isUnread) => {
    // Uncomment these lines to make Watermark feature available
    // const { userName, customerNumber } = this.props;
    // const documentId = _.get(item, "Pdf", "");
    // const text = `${userName} (${customerNumber})`;

    // const { userName, customerNumber } = this.props;
    // const documentId = _.get(item, "Pdf", "");
    // const text = `${userName} (${customerNumber})`;

    if (isUnread) {
      markAsRead([item.CnbId], "Teeltadvies");
    }

    window.open(`${URLS.OPEN_DOCUMENT}/${_.get(item, "Pdf", "")}`);
  };

  private handlePageChange = (meta) => {
    const newMeta = { ...this.state, ...meta };
    this.setState(newMeta);
    this.props.getCultivationAdvices(newMeta, true);
  };

  public render() {
    const { cultivationAdvices, accountMessages, local, count } = this.props;
    const unreadIds = _(accountMessages)
      .filter({ TypeId: "Berichten teeltadvies", Gezien: false })
      .map("EntityId")
      .value();

    return (
      <div id="advices-page">
        <FormattedMessage id="CULTIVATION_ADVICES_HEADER" tagName="h1" />
        {cultivationAdvices.map((item, index) => {
          const isUnread = _.includes(unreadIds, item.CnbId);
          const formattedDate = moment(item.Date).locale("nl").format("LL");

          return (
            <CorneredCard
              color="alice"
              size="big"
              className="advice-card"
              key={index}
            >
              <div className="advice-img">
                <img src={`${getVar("LOCAL_API_URI")}/files/${item.Photo}`} />
              </div>
              <div className="advice-body">
                <p className="advice-date">
                  {formattedDate}
                  {isUnread && (
                    <span className="advice-new">
                      <FormattedMessage id="NEW" />
                    </span>
                  )}
                </p>
                <h2 className="advice-header">{item[`Title_${local}`]}</h2>
                <p className="advice-text">{item[`Teaser_${local}`]}</p>
              </div>
              {item.Pdf && item.Pdf !== "undefined" && (
                <div className="advice-btn">
                  <Button
                    id={`download-advice-${_.get(item, "Pdf", "")}`}
                    className="reversed"
                    icon={<AnimatedArrow />}
                    onClick={() => this.onClickHandle(item, isUnread)}
                  >
                    VIEW_PDF
                  </Button>
                </div>
              )}
            </CorneredCard>
          );
        })}
        {!cultivationAdvices.length && (
          <h2 className="message">
            <FormattedMessage id="NO_DATA" />
          </h2>
        )}
        {!!cultivationAdvices.length && (
          <Pagination
            meta={{ ...this.state, count }}
            onPageChange={this.handlePageChange}
            pageName={CUSTOM_SETTINGS.cultivationAdvice}
          />
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    cultivationAdvices: state.cultivationAdvices.items,
    accountMessages: state.app.accountMessages,
    local: state.app.user.profile.Language,
    count: state.cultivationAdvices.meta.count || 0,
  }),
  {
    getCultivationAdvices: CultivationAdviceActions.getCultivationAdvices,
  }
)(CultivationAdvices);
